/* eslint-env browser */
let _doc = document // TODO make this injectable or resolvable

const nextMatch = (big, small) => {}
const matchClass = 'el-find-result'

// node iterator -> list of nodes in source order
const listerate = (nit) => {
  // nit is nodeIterator
  let arr = []
  for (var node = nit.nextNode(); node; node = nit.nextNode()) {
    arr.push(node)
  }
  return arr
}

const getNodes = (rootNode, nodesToShow = NodeFilter.SHOW_ALL, filter) => {
  var nit = _doc.createNodeIterator(rootNode, nodesToShow, filter)
  return listerate(nit)
}

const getTextNodes = (rootNode, filter) =>
  getNodes(rootNode, NodeFilter.SHOW_TEXT, filter)
const getElementNodes = (rootNode, filter) =>
  getNodes(rootNode, NodeFilter.SHOW_ELEMENT, filter)

// todo: move to test, no practical purpose here
const nodeStats = (node) => {
  let stats = { node }
  stats.textContent = node.textContent || ''
  stats.length = stats.textContent.length
  stats.isTextNode = node.nodeType === Node.TEXT_NODE
  return stats
}

const buildTextMapping = (rootNode) => {
  let textNodes = getTextNodes(rootNode)
  let refText = rootNode.textContent
  let cursor = 0
  let mappings = []
  textNodes.forEach((node, i) => {
    let target = node.textContent
    if (target.length) {
      // don't bother with empty text nodes
      let index = refText.indexOf(node.textContent, cursor)
      if (index === -1) {
        throw Error(
          'problem building mapping data, cannot find text in reference string'
        )
      }
      cursor = index // move cursor past already mapped portion of ref string
      mappings.push({
        node,
        min: cursor, // inclusive
        max: cursor + node.textContent.length, // exclusive
        d: node.textContent.length,
        text: node.textContent,
      })
    }
  })
  return mappings
}

const pointInRangeMapping = (rm, point) => rm.min <= point && rm.max > point

const backMapPoint = (rangeMap) => (point) => {
  let mapping = rangeMap.find((m) => pointInRangeMapping(m, point))
  if (!mapping) {
    return undefined
  }
  return { node: mapping.node, offset: point - mapping.min }
}

const charFromBackMap = (b) => b.node.textContent.charAt(b.offset)

// reduces nodes or objects with textContent property to single string.
const textReducer = (str = '', n) => str + n.textContent

const highlight = (range, attrs = {}) => {
  let mark = document.createElement('mark')
  mark.setAttribute('class', matchClass)
  Object.entries(attrs).forEach(([key, val]) => {
    mark.setAttribute(key, val)
  })
  mark.appendChild(range.extractContents())
  range.insertNode(mark)
}

const wrap = (el, wrapper) => {
  el.parentNode.insertBefore(wrapper, el)
  wrapper.appendChild(el)
  return wrapper
}

const peel = (el) => {
  // cred: https://plainjs.com/javascript/manipulation/unwrap-a-dom-element-35/
  let parent = el.parentNode
  while (el.firstChild) {
    parent.insertBefore(el.firstChild, el)
  }
  parent.removeChild(el)
  return parent
}

// TODO: stop making huge assumptions about content of q
const buildRegex = (q, matchCase = false) => {
  let flags = matchCase ? 'g' : 'gi'
  return new RegExp(q, flags)
}

const matchList = (rgx, str) => {
  let list = []
  for (let res = rgx.exec(str); res; res = rgx.exec(str)) {
    list.push({ index: res.index, length: res[0].length, match: res[0] })
  }
  return list
}

const matchToRange = (rangeMap) => (match) => {
  var range = _doc.createRange()
  let first = backMapPoint(rangeMap)(match.index)
  let last = backMapPoint(rangeMap)(match.index + match.length - 1) // (inclusive)
  range.setStart(first.node, first.offset)
  range.setEnd(last.node, last.offset + 1) // (exclusive)
  return range
}

const find = (el, q, matchCase = false) => {
  let obj = {}
  obj.rootNode = el
  obj.refText = el.textContent
  obj.rangeMap = buildTextMapping(el)
  obj.query = q
  obj.regex = buildRegex(q, matchCase)
  obj.matches = matchList(obj.regex, obj.refText)
  obj.matchRanges = obj.matches.map(matchToRange(obj.rangeMap))
  return obj
}

const removeMarks = (el) => {
  ;[...el.querySelectorAll(`.${matchClass}`)].forEach(peel)
  el.normalize()
  return el
}

// todo: move some statics to _util, to unclutter public api
module.exports = (/* TODO DI for document/window */) => ({
  nextMatch,
  listerate,
  getNodes,
  getTextNodes,
  getElementNodes,
  nodeStats,
  textReducer,
  buildTextMapping,
  backMapPoint,
  matchToRange,
  charFromBackMap,
  highlight,
  wrap,
  peel,
  removeMarks,
  find,
})
